import TPager from './pager.vue'
import TPageSizer from './sizer.vue'
import TPageElevator from './elevator.vue'

TPager.sizer = TPageSizer
TPager.elevator = TPageElevator
export default TPager



// WEBPACK FOOTER //
// ./src/components/pager/index.js